import { jbColors } from '../jbColors';

export const MuiFilledInput = {
  styleOverrides: {
    input: {
      backgroundColor: jbColors.support.greenSmoke[10],
      borderRadius: 0,
    },
    multiline: {
      padding: 0,
    },
  },
};
